export const MOBILE_BANNER_TITLE = 'В_приложении_удобнее_109';
